let Test = require('@/mixins/Forms/2016/NRCA_LTI_03_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            ft_line_c: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_l: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_n: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_o: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_s: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_t: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_u: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_v: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_w: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
            ft_line_x: {
                SKY: 0,
                PS: 0,
                SS: 0,
            },
        }
    },

    methods: {

        // Start evaluation test.
        evaluateTest() {
            this.testResult = 1;
            // Factorize this code
            if (this.skylit) {
                this.calculateLine_L('SKY')
                this.calculateLine_N('SKY')
                this.calculateLine_O('SKY')
                this.calculateLine_T('SKY')
                this.calculateLine_U('SKY')
                this.calculateLine_W('SKY')
                this.calculateLine_X('SKY')
                this.calculateTestResul('SKY')
            }
            if (this.primarySidelit) {
                this.calculateLine_L('PS')
                this.calculateLine_N('PS')
                this.calculateLine_O('PS')
                this.calculateLine_T('PS')
                this.calculateLine_U('PS')
                this.calculateLine_W('PS')
                this.calculateLine_X('PS')
                this.calculateTestResul('PS')
            }
            if (this.secondaySidelit) {
                this.calculateLine_L('SS')
                this.calculateLine_N('SS')
                this.calculateLine_O('SS')
                this.calculateLine_T('SS')
                this.calculateLine_U('SS')
                this.calculateLine_W('SS')
                this.calculateLine_X('SS')
                this.calculateTestResul('SS')
            }
            if (!this.skylit && !this.primarySidelit & !this.secondaySidelit) {
                this.testResult = 0;
            }
            this.form.testResult = !!this.testResult
        },

        // Calculate Line L.
        calculateLine_L(zone) {
            var K = this.asNumber($('input[name="ft_line_k_' + zone + '"]').val());
            var G = this.asNumber($('input[name="ft_line_g_' + zone + '"]').val());
            var D = this.asNumber($('input[name="ft_line_d_' + zone + '"]').val());
            var I = $('input[name="ft_line_i_' + zone + '"]:checked').val();
            if (I == 'FO') {
                this.ft_line_l[zone] = (((K / G) * 100) >= 70) ? 1 : 0;
                return;
            }
            this.ft_line_l[zone] = (((K / D) * 100) >= 80) ? 1 : 0;
        },

        // Calculate Line N.
        calculateLine_N(zone) {
            var M = this.asNumber($('input[name="ft_line_m_' + zone + '"]').val());
            var H = this.asNumber($('input[name="ft_line_h_' + zone + '"]').val());
            if (!isNaN(M) && !isNaN(H) && !this.isBlank(M) && !this.isBlank(H) && M >= 0 && M <= H) {
                var result = (100 - ((M / H) * 100)).toFixed(2);
                this.ft_line_n[zone] = result;
                return;
            }
            this.ft_line_n[zone] = '';
        },

        // Calculate Line O.
        calculateLine_O(zone) {
            var I = $('input[name="ft_line_i_' + zone + '"]:checked').val();
            if (I == 'FO') {
                this.ft_line_o[zone] = (this.ft_line_n[zone] >= 65) ? 1 : 0;
                return;
            }
            this.ft_line_o[zone] = (this.ft_line_n[zone] >= 56) ? 1 : 0;
        },

        // Calculate Line T
        calculateLine_T(zone) {
            var K = this.asNumber($('input[name="ft_line_k_' + zone + '"]').val());
            var S = this.asNumber($('input[name="ft_line_s_' + zone + '"]').val());
            var result = (S / K) * (100);
            if (!isNaN(result)) {
                this.ft_line_t[zone] = result.toFixed(2);
                return;
            }
            this.ft_line_t[zone] = '';
        },

        // Calculate Line U
        calculateLine_U(zone) {
            if ((this.ft_line_t[zone] >= 60) && (this.ft_line_t[zone] <= 95)) {
                this.ft_line_u[zone] = 1;
                return;
            }
            this.ft_line_u[zone] = 0
        },

        // Calculate Line W
        calculateLine_W(zone) {
            var K = this.asNumber($('input[name="ft_line_k_' + zone + '"]').val());
            var V = this.asNumber($('input[name="ft_line_v_' + zone + '"]').val());
            var result = (V / K) * (100);
            if (!isNaN(result)) {
                this.ft_line_w[zone] = result.toFixed(2);
                return;
            }
            this.ft_line_w[zone] = '';
        },

        // Calculate Line X
        calculateLine_X(zone) {
            if ((this.ft_line_w[zone] >= 100) && (this.ft_line_w[zone] <= 150)) {
                this.ft_line_x[zone] = 1;
                return;
            }
            this.ft_line_x[zone] = 0
        },

        // Calculate Test Result
        calculateTestResul(zone) {
            var C = this.asNumber($('input[name="ft_line_c_' + zone + '"]:checked').val());
            var P = this.asNumber($('input[name="ft_line_p_' + zone + '"]:checked').val());
            var Q = this.asNumber($('input[name="ft_line_q_' + zone + '"]:checked').val());
            var R = this.asNumber($('input[name="ft_line_r_' + zone + '"]:checked').val());
            if (this.constructionInspectionResult[zone] == 0) {
                this.testResult = 0;
                return;
            }
            if (C == 0) {
                this.testResult = 0;
                return;
            }
            if (this.ft_line_l[zone] == 0) {
                this.testResult = 0;
                return;
            }
            if (P == 0) {
                this.testResult = 0;
                return;
            }
            if (Q == 0) {
                this.testResult = 0;
                return;
            }
            if (R == 1 && this.ft_line_n[zone] < 100) {
                this.testResult = 0;
                return;
            }
            if (this.ft_line_u[zone] == 0) {
                this.testResult = 0;
                return;
            }
            if (this.ft_line_x[zone] == 0) {
                this.testResult = 0;
                return;
            }
        }
    },

}
